<template>
    <div class="bg-color">
        <Navbar />
        <Header :category="'visitors'" :bannerTitle="bannerTitle" :breadCrumb="borrowSpaceCrumb" />
        <ExhibitionContent />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
    import Navbar from 'components/DefaultHome/Layout/NavbarStyleTwo'
    import Header from 'components/DefaultHome/KECC5G/Common/Header'
    import ExhibitionContent from './ExhibitionContent'
    import FooterTop from 'components/DefaultHome/Layout/FooterTop'
    import FooterBottom from 'components/DefaultHome/Layout/BacktopButton'
    export default {
        name: 'ExhibitionMain',
        components: {
            Navbar,
            Header,
            ExhibitionContent,
            FooterTop,
            FooterBottom,
        },
        data() {
            return {
                bannerTitle: this.$t('navbar.menu_6'),
                borrowSpaceCrumb: [
                    {
                        name: this.$t('navbar.menu_6'),
                        path: "/exhibition"
                    }
                ]
            }
        }
    }
</script>
